import { Box, Button } from '@evaneos/b2b-ui';
import UnfoldMoreIcon from '@evaneos/b2b-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@evaneos/b2b-ui/icons/UnfoldLess';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { SidePanelViewMode } from '../../../SidePanel/types';
import { useSidePanelOptional } from '../../../SidePanel/SidePanelContext';
import s from '../../Contract.css';

type Props = {
    dossierId: string;
    onCreate?: () => void;
    viewMode?: SidePanelViewMode;
};

export const NoContract = ({ dossierId, onCreate, viewMode }: Props): JSX.Element => {
    const { formatMessage } = useIntl();
    // TODO: remove `useSidePanelOptional` hook and use `useSidePanel` when
    // old contract page has been removed. We use in this component a button
    // to expand the side panel that will only be available in the new Dossier view.
    const { isExpanded, toggleExpanded } = useSidePanelOptional() ?? {};
    const isInSidePanel = Boolean(viewMode);

    return (
        <div className={s.contractContainer} {...(viewMode && { 'data-contract-view': viewMode })}>
            <div className={s.contractCard}>
                <div className={s.headerContainer}>
                    <h1 className={[s.title, s.noMarginBottom].join(' ')}>
                        {formatMessage({ id: 'contract.titles.contract' })}
                    </h1>

                    {!isInSidePanel ? (
                        <Button
                            color="primary"
                            replace
                            to={{
                                pathname: `/dossier/${dossierId}/contract/edit`,
                            }}
                            component={Link}
                        >
                            {formatMessage({ id: 'contract.create' })}
                        </Button>
                    ) : null}
                </div>

                {isInSidePanel ? (
                    <Box display="flex" flexDirection="column" gap={3}>
                        <p className={s.lightText} data-testid="no-contract-message">
                            {formatMessage({ id: 'contract.messages.no_contract' })}
                        </p>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {toggleExpanded && (
                                <Button
                                    variant="outlined"
                                    onClick={toggleExpanded}
                                    startIcon={isExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                                    sx={{
                                        display: { xs: 'none', sm: 'inline-flex' },
                                        '& .MuiButton-startIcon svg': {
                                            transform: 'rotate(45deg)',
                                        },
                                    }}
                                >
                                    {formatMessage({
                                        id: isExpanded
                                            ? 'dossier.side_panel.collapse'
                                            : 'dossier.side_panel.expand',
                                    })}
                                </Button>
                            )}
                            <Button color="primary" onClick={onCreate}>
                                {formatMessage({ id: 'contract.create' })}
                            </Button>
                        </Box>
                    </Box>
                ) : null}

                {!isInSidePanel ? (
                    <div className={s.noContractMessageWrapper}>
                        <p className={s.lightText} data-testid="no-contract-message">
                            {formatMessage({ id: 'contract.messages.no_contract' })}
                        </p>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
